import { StyledButton } from "../styled-button/StyledButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsAddingAnnotation,
  updateAnnotations,
} from "../../store/slices/AnnotationSlice";
import {
  Button,
  createStyles,
  Fab,
  IconButton,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { StyledInput } from "../styled-input/StyledInput";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import RemoveIcon from "@material-ui/icons/Remove";

const useStyles = makeStyles((theme) =>
  createStyles({
    annotationBox: {
      borderRadius: "1rem",
      background: "#ececec0d",
      padding: "1rem",
      marginBottom: theme.spacing(3),
      maxWidth: "450pxs",
    },
    annotationLabelInput: {
      borderRadius: "1rem",
      marginBottom: "1rem",
    },
    annotationList: {
      marginRight: "1rem",
      marginBottom: "1rem",
    },
    annotationDelete: {
      right: "31px",
      bottom: "-8px",
      background: "#ff5959",
      "&:hover": {
        background: "#ff5959",
      },
    },
  })
);

const Annotations = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const annotations = useSelector((state) => state.annotations);

  const [currentCtx, setCurrentCtx] = React.useState("");
  const [isSettingAnnotation, setIsSettingAnnotation] = React.useState(false);

  const handleChange = (e, type) => {
    const { name, value } = e.target;
    const newAnnotationsData = JSON.parse(
      JSON.stringify(annotations.annotations)
    );
    let toChangeAnnotation = newAnnotationsData.find((o) => o.id === name);
    switch (type) {
      case "desc":
        toChangeAnnotation.text = value;
        break;
      case "image":
        toChangeAnnotation.mediaImage = value;
        break;
      case "video":
        toChangeAnnotation.mediaVideo = value;
        break;
      case "attachment":
        toChangeAnnotation.attachment = value;
        break;
      default:
        console.log("error, if coming here");
    }
    setCurrentCtx(toChangeAnnotation);
    dispatch(updateAnnotations(newAnnotationsData));
  };

  const removeAnnotation = (id) => {
    let newAnnotationsData = JSON.parse(
      JSON.stringify(annotations.annotations)
    );
    newAnnotationsData = newAnnotationsData.filter(function (obj) {
      return obj.id !== id;
    });
    dispatch(updateAnnotations(newAnnotationsData));
  };

  const editAnnotation = (hotspot) => {
    setCurrentCtx(hotspot);
    setIsSettingAnnotation(true);
  };

  const handleBack = () => {
    setCurrentCtx("");
    setIsSettingAnnotation(false);
  };

  const annotationsList = () => {
    let i = 0;
    return annotations.annotations.map((hotspot) => (
      <span key={Math.random().toString(36).substring(7)}>
        <Fab
          size="small"
          color="primary"
          aria-label="add"
          className={classes.annotationList}
          onClick={() => editAnnotation(hotspot)}
        >
          {++i}
        </Fab>
        <IconButton
          aria-label="delete"
          className={classes.annotationDelete}
          size="small"
          onClick={() => removeAnnotation(hotspot.id)}
        >
          <RemoveIcon fontSize="inherit" />
        </IconButton>
      </span>
    ));
  };

  const EditAnnotation = () => (
    <div>
      <Button
        color="primary"
        startIcon={<ArrowBackIosIcon />}
        onClick={handleBack}
      >
        Edit Annotation
      </Button>
      <h6 className={"p-2 mt-3"}>Annotation details</h6>
      <div
        className={classes.annotationBox}
        key={Math.random().toString(36).substring(7)}
      >
        <StyledInput
          name={currentCtx.id}
          className={classes.annotationLabelInput}
          placeholder={"Enter annotation description"}
          multiline
          rows={3}
          defaultValue={currentCtx.text}
          variant="filled"
          fullWidth
          onBlur={(e) => handleChange(e, "desc")}
        />
        <StyledInput
          name={currentCtx.id}
          placeholder={"Enter image url"}
          className={classes.annotationLabelInput}
          defaultValue={currentCtx.mediaImage}
          variant="filled"
          fullWidth
          onBlur={(e) => handleChange(e, "image")}
        />
        <StyledInput
          name={currentCtx.id}
          placeholder={"Enter video url"}
          className={classes.annotationLabelInput}
          defaultValue={currentCtx.mediaVideo}
          variant="filled"
          fullWidth
          onBlur={(e) => handleChange(e, "video")}
        />
        <StyledInput
          name={currentCtx.id}
          placeholder={"Enter attachment url"}
          className={classes.annotationLabelInput}
          defaultValue={currentCtx.attachment}
          variant="filled"
          fullWidth
          onBlur={(e) => handleChange(e, "attachment")}
        />
      </div>
    </div>
  );

  return (
    <>
      {isSettingAnnotation && <EditAnnotation />}
      {!isSettingAnnotation && (
        <div>
          <h6 className={"p-2"}>Add Annotations</h6>
          <div className={"inner-box p-3 mb-3"}>
            <div className={"p-2"}>
              Select a position on the model to add annotation
            </div>{" "}
            <StyledButton
              variant={"contained"}
              color={"primary"}
              startIcon={<AddIcon />}
              disabled={annotations.isAddingAnnotation}
              onClick={() => dispatch(setIsAddingAnnotation(true))}
            >
              {" "}
              Add Annotation{" "}
            </StyledButton>
          </div>
          {annotations.annotations.length !== 0 && (
            <div>
              <h6 className={"p-2"}>Annotations List</h6>
              <div className={"px-2"} style={{ maxWidth: "416px" }}>
                {annotationsList()}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Annotations;
